export default class AudioPlayer {
  constructor() {
    this.player = document.querySelectorAll(".jsAudio");

    // helpers
    this.players = {};
    this.volume = {
      0: 0.5,
      0.5: 1,
      1: 0
    };

    if (this.player.length > 0) this.init();
  }

  // helpers functions
  formatTime(t) {
    let min = Math.floor(t / 60),
      sec = Math.floor(t % 60);

    return min + ":" + (sec < 10 ? "0" + sec : sec);
  }

  // drag calculate
  getPositionOfClick(el) {
    return el.getBoundingClientRect().left;
  }

  getPercentOfClick(el, distance) {
    return 100 * distance / el.offsetWidth;
  }

  drag(event, id) {
    let distance = event.clientX - this.getPositionOfClick(this.players[id].slider),
      percent = this.getPercentOfClick(this.players[id].slider, distance);

    this.changeAudioTimeline(id, percent);
  }

  updateProgress(id) {
    let p = this.players[id].player,
      current = p.currentTime,
      percent = current / p.duration * 100;

    this.players[id].progress.style.width = percent + "%";
  }

  // change music player timeline
  getPercentOfDuration(percent, duration) {
    return duration * percent / 100;
  }

  changeAudioTimeline(id, percent) {
    let duration = this.players[id].duration,
      progress = this.getPercentOfDuration(percent, duration);

    this.players[id].player.currentTime = progress;
  }

  // change volume
  changeVolume(id) {
    let volume = this.players[id].volume,
      volumeLvl = parseFloat(volume.dataset.volume);

    volume.dataset.volume = this.volume[volumeLvl];
    this.players[id].player.volume = this.volume[volumeLvl];
  }

  // base setup
  setupPlayer(i) {
    let id = i.dataset.id;

    // player
    let player = i.parentElement.querySelector(`#audio-${id}`),
      timeTracking = i.querySelector(".jsAudioTime"),
      progress = i.querySelector(".jsAudioProgress"),
      play = i.querySelector(".jsAudioPlay"),
      volume = i.querySelector(".jsAudioVolume"),
      slider = i.querySelector(".jsAudioSlider"),
      duration = player.duration;

    // connect to main object
    this.players[id] = {
      player,
      progress,
      play,
      volume,
      slider,
      duration
    };

    // initital volume at half
    player.volume = 0.5;

    player.addEventListener("canplay", () => {
      timeTracking.textContent = this.formatTime(player.duration);
    });

    player.addEventListener("timeupdate", () => {
      this.updateProgress(id);
    });

    play.addEventListener("click", () => {
      play.classList.toggle("playing");

      play.classList.contains("playing") ? player.play() : player.pause();
    });

    volume.addEventListener("click", () => {
      this.changeVolume(id);
    });

    slider.addEventListener("click", event => {
      this.drag(event, id);
    });
  }

  init() {
    for (let i = 0; i < this.player.length; i++) {
      this.setupPlayer(this.player[i]);
    }
  }
}
